import { getMiniHostAppDetail } from 'mini-host-bridge/lib/getMiniHostAppDetail';
import { isThemeModeSetByHostApp } from './isThemeModeSetByHostApp';

export const isSystemDark = (): boolean => {
    if (isThemeModeSetByHostApp()) {
        return getMiniHostAppDetail().isDarkTheme;
    }

    return window.matchMedia?.('(prefers-color-scheme: dark)').matches;
};
